import request from '@/utils/request'
import { setToken, setUserInfo } from '@/utils/auth'
import axios from 'axios'

// 登录
export function login(data) {
  const baseUrl = process.env.NODE_ENV === 'production' ? '/api' : (process.env.VUE_APP_BASE_API || '/api');
  
  // 创建一个专用的axios实例
  const loginAxios = axios.create({
    baseURL: baseUrl,
    timeout: 30000,
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  });
  
  console.log('--- 开始登录请求 ---');
  console.log('尝试登录请求，数据:', {...data, password: '***隐藏***'});
  
  return loginAxios({
    url: '/v1/auth/login',
    method: 'post',
    data: data
  }).then(response => {
    console.log('--- 登录请求成功 ---');
    
    if (response.data && response.data.data) {
      if (response.data.data.token) {
        setToken(response.data.data.token);
        console.log('已保存token到localStorage');
      }
      if (response.data.data.user) {
        setUserInfo(response.data.data.user);
        console.log('已保存用户信息到localStorage');
      }
    }
    
    return response.data;
  }).catch(error => {
    console.error('--- 登录请求失败 ---');
    console.log('错误详情:', {
      message: error.message,
      status: error.response?.status,
      statusText: error.response?.statusText,
      data: error.response?.data
    });
    return Promise.reject(error);
  });
}

// 登出
export function logout() {
  return request({
    url: '/v1/auth/logout',
    method: 'post'
  })
}

// 获取用户信息
export function getUserInfo() {
  return request({
    url: '/v1/auth/user-info',
    method: 'get'
  })
}

// 更新用户信息
export function updateUserInfo(data) {
  return request({
    url: '/v1/auth/user-info',
    method: 'put',
    data
  })
}

// 更新密码
export function updatePassword(data) {
  return request({
    url: '/v1/auth/password',
    method: 'put',
    data
  })
}

// 兼容旧代码: changePassword 与 updatePassword 同义
export const changePassword = updatePassword;

// 更新头像
export function updateAvatar(data) {
  return request({
    url: '/v1/auth/avatar',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data
  })
}

// 获取微信登录二维码
export function getWechatQrcode() {
  console.log('调用获取二维码API')
  return request({
    url: '/v1/auth/wechat/qrcode',
    method: 'get'
  })
}

// 检查微信登录状态
export async function checkLoginStatus(params) {
  console.log('调用检查登录状态API, 参数:', params)
  if (!params.state) {
    console.warn('缺少state参数')
    throw new Error('缺少state参数')
  }
  return request({
    url: '/v1/auth/wechat/check-status',
    method: 'get',
    params
  })
}

// 上传头像
export function uploadAvatar(data) {
  return request({
    url: '/v1/auth/avatar',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data
  })
}

// 绑定手机号
export function bindPhone(data) {
  return request({
    url: '/v1/auth/bind-phone',
    method: 'post',
    data
  })
}

// 绑定邮箱
export function bindEmail(data) {
  return request({
    url: '/v1/auth/bind-email',
    method: 'post',
    data
  })
}

// 发送验证码
export function sendVerifyCode(data) {
  return request({
    url: '/v1/auth/send-code',
    method: 'post',
    data
  })
}

// 验证验证码
export function verifyCode(data) {
  return request({
    url: '/v1/auth/verify-code',
    method: 'post',
    data
  })
}

// 获取 CSRF token - 方案二中此函数已不再需要，但保留以维持兼容性
export function getCsrfToken() {
  console.log('--- CSRF功能已移除 ---');
  console.log('此函数不再执行实际操作，直接返回成功');
  
  return Promise.resolve({
    code: 200,
    message: 'CSRF功能已移除',
    token: null
  });
}

/**
 * 检查内部网站访问权限
 * @param {number} userId - 用户ID
 */
export function checkInternalSiteAccess(userId) {
  return request({
    url: `/v1/auth/internal-site-access/check/${userId}`,
    method: 'get'
  })
}